import { Component, type ErrorInfo, type ReactNode } from "react";
import ErrorPage from "./ErrorPage";
import { captureError } from "../lib/sentry";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Sentry capture is a no-op until `VITE_SENTRY_DSN` is set
    // (Hector kickoff to-do). Local console always logs.
    captureError(error, info);
    console.error("ErrorBoundary caught:", error, info);
  }

  reset = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    if (this.state.error) {
      return <ErrorPage error={this.state.error} onReset={this.reset} />;
    }
    return this.props.children;
  }
}
